export default "__VITE_ASSET__Duc9bZoU__"